import { render, staticRenderFns } from "./BoxGroup.vue?vue&type=template&id=95d9a78e&scoped=true"
import script from "./BoxGroup.vue?vue&type=script&lang=js"
export * from "./BoxGroup.vue?vue&type=script&lang=js"
import style0 from "./BoxGroup.vue?vue&type=style&index=0&id=95d9a78e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d9a78e",
  null
  
)

export default component.exports